var nextUniqueId = 0;
export default function getNextUniqueId() {
  return nextUniqueId++;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/dnd-core/dist/esm/utils/getNextUniqueId.js
// module id = 1472
// module chunks = 71